'use client'

import { css } from '@lastbrand/web-ui-styled-system/css'

// Figma "More to Explore" band (nodes 6236:51261 desktop / 6236:47019 mobile): full-bleed section with
// `space/48` desktop horizontal gutters (mobile `space/16`), and `Content` vertical padding — desktop
// top `space/64` + bottom `space/100`, mobile top `space/48` + bottom `space/48`.
export const sectionClass = css({
  display: 'flex',
  flexDirection: 'column',
  px: { base: 'space-16', lg: 'space-48' },
  paddingTop: { base: 'space-48', lg: 'space-64' },
  paddingBottom: { base: 'space-48', lg: 'space-100' },
})

// Mirrors ProductListSectionThreeDS — containerType + item sizing via descendant selector so cqi units
// resolve against this wrapper, not the viewport. Capped at the Figma `widget/max-w` 1504 and centred.
// Header→content gap is the Figma `Content` gap: `space/48` desktop, `space/24` mobile (6236:47019 —
// title ends y=68, first Row starts y=92). Each carousel slot is one product card on desktop (4-up)
// and one full-width 2×2 page on mobile (flexBasis 100% → one page per snap).
export const carouselWrapperClass = css({
  display: 'flex',
  flexDirection: 'column',
  width: 'full',
  maxWidth: '1504px',
  marginInline: 'auto',
  gap: { base: 'space-24', lg: 'space-48' },
  containerType: 'inline-size',
  '& [data-slot="carousel-content"]': {
    gap: { base: 'space-16', lg: 'space-24' },
  },
  // Desktop only: mobile renders `MobileScrollCarousel`'s own page divs, so nothing carries
  // `data-slot="carousel-item"` below `lg` and a `base` value here could never match.
  '& [data-slot="carousel-item"]': {
    minWidth: 0,
    flexGrow: 0,
    flexShrink: 0,
    flexBasis: { lg: 'calc((100cqi - 3 * var(--web-ui-spacing-space-24)) / 4)' },
  },
})

// Mobile 2×2 page (Figma node 6236:47019): 2-col grid of up to 4 cards per carousel slide. Explicit
// columnGap/rowGap (NOT the `gap` shorthand) so Panda's atomic ordering can't shadow the column gap —
// columnGap `widget/space/16`, rowGap `widget/space/24` (mirrors the SimilarProducts mobile 2×2).
export const mobileGridClass = css({
  display: 'grid',
  width: 'full',
  gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
  columnGap: 'space-16',
  rowGap: 'space-24',
})

// Figma mobile dots `Wrapper` (6236:47019 / 6236:19482 — a 358×40 band at y=711.99 holding the 8px
// indicator at y=16, with the last Row ending at 687.99): `space-24` below the grid plus `space-16`
// of padding above and below the dots. Merged into `MobileScrollCarousel`'s own dots-row style, whose
// default `space-16` top gap belongs to the non-PL `product-list-section-two` band.
export const mobileDotsRowCssRaw = css.raw({
  marginTop: 'space-24',
  paddingBlock: 'space-16',
})

export const headerRowClass = css({
  display: 'flex',
  alignItems: 'center',
  gap: 'space-16',
  width: 'full',
})

// Title — the Figma "More to Explore" eyebrow: Grosa Medium, UPPERCASE, 0.05em tracking. The DS
// `title-16` (desktop `title/16`) and `title-14` (mobile `title/14`) textStyles already carry the
// uppercase + letter-spacing, so the source copy stays normal-case (CSS uppercases it). NOT the
// decorative ivy `-dec` serif — PDP reco swimlanes use the upright grosa eyebrow.
export const headingClass = css({
  textStyle: { base: 'title-14', lg: 'title-16' },
  color: 'black',
  textAlign: 'left',
  flex: '1 0 0',
  minWidth: 0,
})

export const navGroupClass = css({
  display: { base: 'none', lg: 'flex' },
  gap: 'space-4',
  alignItems: 'center',
  flexShrink: 0,
  marginLeft: 'auto',
})
